import FormInput from 'components/forms/FormInput';
import {
    formatPrimaryPrice,
    formatRateLine,
    getPriceEditDefaultValue,
    getPriceEditPrefix,
    getSaleUsd,
    shouldShowRateLine,
} from './model/templatePriceUtils';
import { useEffect, useRef } from 'react';

export interface TemplatePriceCellProps {
    row: { priceSale?: number; price?: number };
    rate: number;
    disabled: boolean;
    isEditing: boolean;
    editRatePrice: boolean;
    onOpen: (editRatePrice: boolean) => void;
    onClose: () => void;
    onSave: (value: string | number) => void;
}

const priceLineClass = (disabled: boolean) =>
    `text-muted f-12 mb-0 my-1${disabled ? '' : ' template-price-edit text-break'}`;

const TemplatePriceCell = ({
    row,
    rate,
    disabled,
    isEditing,
    editRatePrice,
    onOpen,
    onClose,
    onSave,
}: TemplatePriceCellProps) => {
    const saleUsd = getSaleUsd(row);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isEditing && refInput.current) {
            refInput.current.select();
        }
    }, [isEditing]);


    if (isEditing && !disabled) {
        return (
            <FormInput
                autoSelect={true}
                key={String(editRatePrice)}
                compact
                showForm
                setShowForm={(show) => {
                    if (!show) onClose();
                }}
                defaultValue={getPriceEditDefaultValue(row, rate, editRatePrice)}
                decimalPlaces={2}
                prefix={getPriceEditPrefix(rate, editRatePrice)}
                callBack={onSave}
                refInput={refInput}
            />
        );
    }

    return (
        <>
            <p
                className={priceLineClass(disabled)}
                onClick={() => !disabled && onOpen(false)}
            >
                {formatPrimaryPrice(saleUsd, rate)}
            </p>
            {shouldShowRateLine(rate) && (
                <p
                    className={priceLineClass(disabled)}
                    onClick={() => !disabled && onOpen(true)}
                >
                    {formatRateLine(saleUsd, rate)}
                </p>
            )}
        </>
    );
};

export default TemplatePriceCell;
